import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Page } from '../domain/page.model';
import { DpInventoryDomainBlock, DpInventoryDomainBlockId } from '../domain/bd/dp-inventory-domain-block.model';
import { HttpUtils } from '../utils/http-utils';


@Injectable()
export class AdStatsDpInventoryBlockedDomainsService {
  constructor(private http: HttpClient) {
  }

  create(req: DpInventoryDomainBlock): Observable<DpInventoryDomainBlock> {
    return this.http.post<DpInventoryDomainBlock>(`${environment.serviceUrl}/ad-stats/dp-inventory-blocked-domain`, req);
  }

  delete(req: DpInventoryDomainBlockId) {
    return this.http.delete(`${environment.serviceUrl}/ad-stats/dp-inventory-blocked-domain`, {
      params: HttpUtils.getHttpParams(req)
    });
  }

  getPage(req: DpInventoryDomainBlockPageRequest): Observable<Page<DpInventoryDomainBlock>> {
    return this.http.get<Page<DpInventoryDomainBlock>>(`${environment.serviceUrl}/ad-stats/dp-inventory-blocked-domain`, {
      params: HttpUtils.getHttpParams(req)
    });
  }
}

export class DpInventoryDomainBlockPageRequest {
  size: number;
  page: number;
  sortField?: string;
  url?: string;
  demandPartner?: string;
  publisherId?: string;
  sortDirection?: 'DESC' | 'ASC';
}
